import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import RespSidebar from "./RespSidebar";
import { motion } from "framer-motion"
import TypingText from "./TypingText";
import FadeAnimation from "./FadeAnimation";
import ContentCreationBox from "./ContentCreationBox";
import BeyondTheCode from "./BeyondTheCode";

export default function Home() {
  const [Drop, setDrop] = useState(false);
  return (
    <div>
      <main>
        {Drop ? (
          <RespSidebar setDropDown={setDrop} />
        ) : (
          <Sidebar setDropDown={setDrop} />
        )}

        <div className="main-content">
          <Navbar link="home" />
          <article className="about active flex" data-page="about">
            <header>
              <h2 className="h2 article-title"><TypingText textList={["Java FullStack Developer","About Me"]} /></h2>
            </header>
            <section className="about-text">
              <p>
                Hi, I'm Ujwal Hiranwar, a Full Stack Developer working with Java/Spring Boot and React. 
                I'm passionate about building well architected web applications and exploring 
                how AI and DevOps practices can make software delivery faster and more reliable. 
                I'm always learning from cloud-native patterns to applied AI/ML and I care 
                about shipping products that genuinely solve problems for the people using them. 
                If you're looking for someone who blends strong fundamentals with curiosity and 
                a collaborative mindset, I'd love to connect and explore how we can work together.
              </p>
            </section>
            <section className="service flex flex-col">
              <h3 className="h3 service-title">What i'm doing</h3>
              <ul className="grid grid-cols-2 sm:grid-cols-1 gap-6">
              <motion.div
      
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1,delay:1*0.8, repeat: Infinity,repeatType: "reverse",repeatDelay: 2 }}
    >
                <li className="service-item flex flex-col">
                  <div className="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="ionicon spring"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M321.89 171.42C233 114 141 155.22 56 65.22c-19.8-21-8.3 235.5 98.1 332.7 77.79 71 197.9 63.08 238.4-5.92s18.28-163.17-70.61-220.58zM173 253c86 81 175 129 292 147"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="32"
                    />
                  </svg>
                  </div>
                  <div className="service-content-box">
                    <b><h4 className="h4 service-item-title font-[Poppins] font-sans"><FadeAnimation textList={["Spring Boot", "Microservices", "Spring Ecosystem"]} /></h4></b>
                    <p className="service-item-text">
                       <FadeAnimation textList={["A Framework for Enterprise level Apps.", "Built in Eureka and Spring cloud support","Spring Security, Spring JPA, Spring cloud etc.." ]} />
                    </p>
                  </div>
                </li>
                </motion.div>
                <motion.div
      
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1,delay:2*0.8, repeat: Infinity,repeatType: "reverse",repeatDelay: 2  }}
    >
                <li className="service-item flex flex-col">
                  <div className="icon-box">
    
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="ionicon spring "
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M448 341.37V170.61A32 32 0 00432.11 143l-152-88.46a47.94 47.94 0 00-48.24 0L79.89 143A32 32 0 0064 170.61v170.76A32 32 0 0079.89 369l152 88.46a48 48 0 0048.24 0l152-88.46A32 32 0 00448 341.37z"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="27"
                    />
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="27"
                      d="M69 153.99l187 110 187-110M256 463.99v-200"
                    />
                  </svg>
                  </div>
                  <div className="service-content-box">
                  <b><h4 className="h4 service-item-title font-[Poppins] font-sans">
                    <FadeAnimation textList={["Docker Containerization", "Kubernetes","Container Orchestration" ]} />
                    </h4></b>
                    <p className="service-item-text">
                      <FadeAnimation textList={["Creating containers from images and Dockerfile.", "Pods Load Balancing and Autoscaling (HPA)","K8's commands to orchestrate pods" ]} />
                    </p>
                  </div>
                </li>
                </motion.div>
                <motion.div
      
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1,delay:3*0.8, repeat: Infinity,repeatType: "reverse",repeatDelay: 2  }}
    >
                <li className="service-item flex flex-col">
                  <div className="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="ionicon spring"
                    viewBox="0 0 512 512"
                  >
                    <path
                      d="M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c37.51 0 71-22.41 94-48M256 256s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-37.51 0-71 22.41-94 48"
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-miterlimit="10"
                      stroke-width="32"
                    />
                  </svg>
                  </div>
                  <div className="service-content-box">
                  <b><h4 className="h4 service-item-title font-[Poppins] font-sans">
                    <FadeAnimation textList={["Practicing DevOps", "Jenkins CI/CD","Hashnode Blogs" ]} />
                    </h4></b>
                    <p className="service-item-text">
                      <FadeAnimation textList={["Creating containers from images and Dockerfile.", "Pods Load Balancing and Autoscaling (HPA)","I like to do technical writing on Hashnode." ]} />
                    </p>
                  </div>
                </li>
                </motion.div>
              </ul>
            </section>
            <section>
            <h3 className="h3 testimonials-title">
              Content Creation
              </h3>
              <ul className="flex sm:flex-col justify-between has-scrollbar overflow-hidden">
                 <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut', delay: 0.3 }}
    
    >
               <li className="mb-8 ">
               
                  <ContentCreationBox social="Medium" name="Technical Writing Blogs" username="@ujwalhiranwar" source="https://ujwalhiranwar.medium.com/" bio="Here I write some blogs relted to advancement in Tech and Software Engineering." linktext="View my blogs" />
               </li>
               </motion.div>
               <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut', delay: 0.3 }}
    
    >
               <li className="mb-8 ">
               
               <ContentCreationBox social="Youtube" name="Youtube Videos" username="@ujwalhiranwar" source="https://www.youtube.com/@ujwalhiranwar" bio="I make youtube videos ones to teach intresting stuff related to tech." linktext="View my channel"/>
            </li>
            </motion.div>
              </ul>
            </section>
            <section>
              <BeyondTheCode />
            </section>
          </article>
        </div>
      </main>
    </div>
  );
}
